import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import Product from '~/containers/product/product';

export class ProductPage extends Component {
  state = {
    product: null
  };

  onReceiveProduct = ({ product }) => {
    this.setState({
      product
    });
  };

  render() {
    const productId = this.props.match.params.productId;
    const { product } = this.state;

    const editButton = (
      <Link to={`/products/${productId}/edit`}>
        <Button color="primary">Edit</Button>
      </Link>
    );

    return (
      <Page>
        <TitleBar back="/products" backText="Products" title={product ? product.name : '...'} button={editButton} />
        <Product onCompleted={this.onReceiveProduct} id={productId} />
      </Page>
    );
  }
}

export default connect(state => ({
  brewery: state.brewery
}))(withRouter(ProductPage));



// WEBPACK FOOTER //
// ./src/pages/product/product.jsx